import React from 'react';
import { Layout, Col, Row, Typography } from 'antd';

import IconBack from 'resources/img/icons/btn-back.png';
import History from 'helpers/History';
import { useNavigate, useSearchParams } from 'react-router-dom';

const { Title } = Typography;

const Header = (props) => {
   const { type, title, isWebview = 'false' } = props;
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const back = searchParams.get('isBack');
   const handleGoToFirstPage = () => {
      navigate(-window.history.length + 2);
   };

   return (
      <Layout.Header
         className={type === 'index' && 'header-bottom'}
         style={
            type === 'index'
               ? { maxWidth: 500 }
               : type === 'none'
               ? { display: 'none' }
               : { display: 'flex' }
         }
      >
         <Row
            justify="center"
            align="middle"
            style={{ maxWidth: 500, width: '100%' }}
         >
            <Col span={24}>
               <Row
                  justify="center"
                  align="middle"
                  className={type === 'index' && 'header-icon-section'}
               >
                  {isWebview === 'false' && (
                     <svg
                        width="18"
                        height="17"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() =>
                           back === 'true'
                              ? handleGoToFirstPage()
                              : History.back()
                        }
                        className="btn-back"
                     >
                        <path
                           d="M8.36108 1.38885L1 8.5M1 8.5L8.36108 15.6111M1 8.5H17"
                           stroke="#EA217A"
                           strokeWidth="2"
                           strokeLinecap="round"
                           strokeLinejoin="round"
                        />
                     </svg>
                  )}
                  <Col className="header-title">
                     <Title level={4} style={{ margin: 0 }}>
                        {title}
                     </Title>
                  </Col>
               </Row>
            </Col>
         </Row>
      </Layout.Header>
   );
};

export default Header;
